import type z from "zod";
import type { BlockType } from "../types";
import { ContainerBlockDefs } from "./containers";
import { LeafBlockDefs } from "./leaf";
import type { Region } from "./regions";

export const BlockDefs = {
  ...LeafBlockDefs,
  ...ContainerBlockDefs
} as const;

export type BlockDefMeta = {
  type: BlockType;
  label: string;
  allowedRegions: readonly Region[];
  maxPerLayout?: number;
  maxPerRegion?: number;
  requiresFeature?: readonly string[];
  propsSchema: z.ZodTypeAny;
  componentName: string;
};

export const BlockDefsMeta = BlockDefs as Record<BlockType, BlockDefMeta>;